import styled from 'styled-components'
import Cleave from 'cleave.js/react'

/*
  O país e o número são um campo só: o contêiner tem a borda, os cantos e o anel de foco da caixa
  do @cutilei/ui (36 px), pelas variáveis dos tokens, e as duas partes ficam sem borda dentro dele.
*/
export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  border: 1px solid var(--input);
  border-radius: 9999px;
  background-color: var(--background);
  cursor: ${props => props.disabled ? 'not-allowed' : 'text'};

  &:focus-within {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
  }

  & [data-slot='combobox-trigger'] {
    height: 34px;
  }
`

export const PhoneInputWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`

export const MaskedInput = styled(Cleave)`
  width: 100%;
  height: 34px;
  border: 0px;
  padding: 0px 12px 0px 0px;
  background-color: transparent;
  font: inherit;
  font-size: 14px;
  color: var(--foreground);
  text-align: left;
  cursor: ${props => props.disabled ? 'not-allowed' : 'text'};

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px var(--background) inset !important;
    box-shadow: 0 0 0 30px var(--background) inset !important;
    -webkit-text-fill-color: var(--foreground) !important;
  }

  &::placeholder {
    color: var(--muted-foreground);
  }

  &:focus {
    border: none;
    outline: none;
  }
`
